<script setup lang="ts">
import { computed } from "vue";
import { Variants } from "@/interface/gloabl";

const props = withDefaults(
  defineProps<{
    variant?: Variants;
  }>(),
  {
    variant: "secondary",
  },
);

const classNames = computed(() => {
  const { variant } = props;
  const borderColor = `border-${variant}`;
  const bgColor = `bg-${variant == "primary" ? "primary-light" : "light"}`;
  return [borderColor, bgColor];
});
</script>
<template>
  <div :class="classNames" class="card border-bold rounded-lg shadow-sm mb-3">
    <div class="card-body text-center py-3">
      <slot></slot>
    </div>
  </div>
</template>
